import * as fromReducer from './configuration-profile.reducer';
import { ConfigurationProfile, ConfigurationProfileState } from './configuration-profile.state';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DevicesRouterStoreSelectors } from '../router';

export const selectConfigurationProfileState = createFeatureSelector<ConfigurationProfileState>(
  fromReducer.configurationProfileFeatureKey
);

export const selectConfigurationProfiles = createSelector(
  selectConfigurationProfileState,
  fromReducer.selectAllConfigurationProfiles
);

export const selectConfigurationProfileEntities = createSelector(
  selectConfigurationProfileState,
  fromReducer.selectConfigurationProfileEntities
);

export const selectConfigurationProfileIds = createSelector(
  selectConfigurationProfileState,
  fromReducer.selectConfigurationProfileIds
);

export const selectConfigurationProfileByUdid = createSelector(
  selectConfigurationProfiles,
  DevicesRouterStoreSelectors.selectUdid,
  (profiles: ConfigurationProfile[], udid: string) => profiles.filter((profile) => profile.udid === udid)
);

export const selectConfigurationProfileByUdidAndPayloadUUID = (payloadUUID: string) =>
  createSelector(selectConfigurationProfileByUdid, (profiles: ConfigurationProfile[]) =>
    profiles.find((profile) => profile.payloadUUID === payloadUUID)
  );
